
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import {
	getSearchDate,
	nextDay
} from "@/utils"
import {
	productpopoverproductlist
} from '@/api/supplier';
import {
	imgHost
} from "@/utils/config"

@Component({
	name: '',
	components: {
		PageFooter
	}
})

export default class ProductList extends Vue {
	@Prop({ default: '' }) modekey!: ''
	private total = 0
	@Inject() information: any
	get value() {
		return this.information
	}
	@Inject() editinfo: any
	get editmsg() {
		let msg = this.information.find(v => {
			return v.key == this.modekey
		})
		return msg
	}
	@Watch('information', { deep: true })
	private getmsg() {
		this.getProductList();
	}

	private products = [];

	private mounted() {
		// this.getshoplist()
		this.getProductList();
	}

	private formatDate(dt) {
		let year = dt.getFullYear();
		let month = dt.getMonth() + 1;
		let day = dt.getDate();
		month = month > 9 ? month : ('0' + month);
		day = day > 9 ? day : ('0' + day);
		return {
			text: `${month}月${day}日`,
			date: `${year}-${month}-${day}`
		};
	}

	private getProductList() {
		let key = this.formatDate(new Date()).date;
		console.log(this.editmsg.someDayData[key])
		let list = this.editmsg.someDayData[key];
		let products = [];
		if (list) {
			list.map(item => {
				if (products.length < 3) {
					if (item.type === 1) {
						item.showQi = item.GroupPrice < item.GroupPriceMax;
						products.push(item)
					} else {
						if (item.areaName && item.products.length && item.picture1) {
							let prices = item.products.map(item => { return item.GroupPrice });
							let prices1 = item.products.map(item => { return item.Price });

							let showQi = item.products.filter(obj => { return obj.GroupPrice < obj.GroupPriceMax }).length >= 1;
							let min = Math.min(...prices);
							let max = Math.max(...prices);
							if (!showQi && min < max) {
								showQi = true;
							}

							products.push({
								ProductThumbImgUrlComplete: imgHost + item.picture1,
								ProductName: item.areaName,
								SellPoint: item.areaDesc,
								GroupPrice: Math.min(...prices),
								GroupPriceMax: Math.max(...prices),
								Price: Math.min(...prices1),
								showQi: showQi
							})
						}
					}
				}

			})
		}

		this.products = products;
	}

	private async getshoplist() {
		try {
			let data: any = {
				Skip: 0,
				Take: 9999,
				Keywords: '',
				ProductCategoryId: '',
				IsOpen: true,
				IsShowDataColumn: true,
				StartTime: getSearchDate(2)[0],
				EndTime: nextDay(getSearchDate(2)[0], 1),
				OrderBy: 'Sort',
				IsAsc: false,
			}
			let res = await productpopoverproductlist(data)
			if (res.IsSuccess) {
				let msg: any = {}
				let num = -1
				this.total = res.Result.Total
				this.information.map((v, i) => {
					if (v.key == this.modekey) {
						msg = v
						num = i
					}
					return
				})
				if (num > -1) {
					msg.shoplist = res.Result.Results.slice(0, 3).map(v => {
						return {
							ProductThumbImgUrlComplete: v.ProductThumbImgUrlComplete,
							ProductName: v.ProductName,
							GroupPrice: v.GroupPrice,
							SellPoint: v.SellPoint,
							GroupPriceMax: v.GroupPriceMax,
							Price: v.Price,
						}
					})
					// console.log(msg.shoplist)
					this.$set(this.information, num, msg)
				}
				// console.log(this.information)
			}
		} finally {
			//
		}
	}
	private todaydate() {
		let list = [-2, -1]
		let date = list.map(v => {
			let date = nextDay(getSearchDate(2)[0], v).split('-').slice(-2)
			return date[0] + '月' + date[1] + '日'
		})
		return date
	}
}
